import React from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faCompass, faUser, faStar, faMusic, faChartBar } from '@fortawesome/free-solid-svg-icons';
import './Navbar.css';

const Navbar = () => (
  <nav className="wow-navbar">
    <NavLink to="/" className={({ isActive }) => isActive ? 'active' : ''} end>
      <FontAwesomeIcon icon={faHome} /> Accueil
    </NavLink>
    <NavLink to="/explore" className={({ isActive }) => isActive ? 'active' : ''}>
      <FontAwesomeIcon icon={faCompass} /> Explorer
    </NavLink>
    <NavLink to="/notation" className={({ isActive }) => isActive ? 'active' : ''}>
      <FontAwesomeIcon icon={faStar} /> Notation
    </NavLink>
    <NavLink to="/playlists" className={({ isActive }) => isActive ? 'active' : ''}>
      <FontAwesomeIcon icon={faMusic} /> Playlists
    </NavLink>
    <NavLink to="/stats" className={({ isActive }) => isActive ? 'active' : ''}>
      <FontAwesomeIcon icon={faChartBar} /> Statistiques
    </NavLink>
    <NavLink to="/profile" className={({ isActive }) => isActive ? 'active' : ''}>
      <FontAwesomeIcon icon={faUser} /> Profil
    </NavLink>
  </nav>
);

export default Navbar; 